export default from './DesktopMessages';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/index.js